import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { DashboardActionTypes } from './constants';

import {Dashboard } from './api';
/**
 * Login the user
 * @param {*} payload - username and password
 */


function* dashboardDataGetFunction(data) {
    try {
        yield put({
            type: DashboardActionTypes.DASHBOARD_DATA_LOADING,
            payload: {},
        });
        const response = yield call(Dashboard,data);
        if (response?.status===200) {
            yield put({
                type: DashboardActionTypes.DASHBOARD_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: DashboardActionTypes.DASHBOARD_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: DashboardActionTypes.DASHBOARD_DATA_ERROR,
            payload: error,
        });
    }
}


export function* watchDashboardDataGet() {
    yield takeEvery(DashboardActionTypes.DASHBOARD_DATA_FIRST, dashboardDataGetFunction);
}
function* dashboardSaga() {
    yield all([
        fork(watchDashboardDataGet),
    ]);
}
export default dashboardSaga;